
export enum ShiftCd {
	DAY_RESHIP = 'DayReship',
	INBOUND = 'Inbound',
	NIGHT_FAC = 'NightFAC',
	OUTBOUND = 'Outbound'}

